import ExpertConsultationsDetail, {
  getStaticProps,
  getStaticPaths,
} from './ConsultationsTabPage'

export { getStaticProps, getStaticPaths }

export default ExpertConsultationsDetail
